export const selectSkillsState = state => state.skills;
export const selectSkillObjectState = state => state.skills.skill;
